import { get, post, qqsPost } from "./http";
const apiList = {
  //获取视频列表
  getConfig(params) {
    return post("/config/index", params);
  },
  //获取socket链接路径
  getSocketPath(params) {
    return post("/config/connect", params);
  },
  //获取当前排队人数
  getQueueLength(params) {
    return post("/temporary-talk/queue-length", params);
  },
  // 获取客服在线状态
  getCustomerStatus(params) {
    return post("/customer-service/show", params);
  },
  // 会话列表
  getUser(params) {
    return post("/talk/index", params);
  },
  // 获取单个用户历史对话
  getDetailConversion(params) {
    return post("/message/index", params);
  },
  // cos获取bucket和region
  getBucket(params) {
    return post("/cos/show", params);
  },
  // 获取上传签名
  getCredentialForUpload(params) {
    return post("/cos/get-credential-for-upload", params);
  },
  // 获取查看签名
  getCredentialForRead(params) {
    return post("/cos/get-credential-for-read", params);
  },
  // 查看所有客服
  getCustomerList(params) {
    return post("/customer-service/index", params);
  },
  // 获取快捷回复语列表
  getQuickreplyList(params) {
    return post("/quick-reply/list", params);
  },
  // 添加回复语类别
  quickReplyAddType(params) {
    return post("/quick-reply/add-type", params);
  },
  // 编辑回复语类别
  quickReplyUpdateType(params) {
    return post("/quick-reply/update-type", params);
  },
  // 删除回复语类别
  quickReplyRemoveType(params) {
    return post("/quick-reply/remove-type", params);
  },
  // 添加回复语
  quickReplyAdd(params) {
    return post("/quick-reply/add", params);
  },
  // 编辑回复语
  quickReplyUpdate(params) {
    return post("/quick-reply/update", params);
  },
  // 删除回复语
  qucikReplyRemove(params) {
    return post("/quick-reply/remove", params);
  },
  // 用户基本信息
  getUserBasicInfomation(params) {
    return post("/customer/show", params);
  },
  // 用户详细信息
  getUserDetailInfo(params) {
    return qqsPost("user/show", params);
  },
  // 客服登陆
  customerLogin(params) {
    return qqsPost("/customerService/login", params);
  },
  // 送礼记录
  sendGiftRecord(parmas) {
    return qqsPost("/statsXiangQ/giftRecord", parmas);
  },
  // 提现记录
  getWithrdaw(params) {
    return qqsPost("/admin/withdraw", params);
  },
  // 消息已读状态
  getMessageIsRead(params) {
    return post("/talk/show", params);
  },
  // 查询自动回复语
  getAutoReply(params) {
    return post("/auto-reply/show", params);
  },
  // 编辑自动回复语
  editAutoReply(params) {
    return post("/auto-reply/update", params);
  },
  // 匿名用户登陆
  anonymousLogin(params) {
    return post("/customer/loginCustomerServiceAnonymous", params);
  },
  // 已登陆用户登陆
  loginCustomer(params) {
    return post("/customer/loginCustomerService", params);
  },
  // 搜索用户
  searchUser(params) {
    return post("/search/talk-detail", params);
  },
  // 查看排队中的用户
  searchQueueuser(params) {
    return post("/temporary-talk/wait-line", params);
  },
  // 搜索客服会话列表
  serachCusList(params) {
    return post("/search/talk-list-of-cs", params);
  },
  // 高级客服全部接待
  searchAllList(params) {
    return post("/talk/index-all", params);
  },
  // 获取会话状态人数
  getStatus(params) {
    return post("/customer-service/count-talk", params);
  },
  // 图片64查询
  pornImage(params) {
    return qqsPost("/admin/pornImage", params);
  }
};
export default apiList;



// WEBPACK FOOTER //
// ./src/http/api.js